export default function getResource(label, vars = []) {
    const resources = {
        clientDetails: 'Renseignements sur le ou la membre de la clientèle',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        emailAddress: 'Courriel',
        textNotifications: 'Notifications par textos',
        phoneNumber: 'Numéro de téléphone',
        smsReminder: 'Oui, veuillez m’envoyer des rappels par message texte au sujet de mon rendez-vous.',
        iAgree: 'J’accepte les',
        textTerms: 'MODALITÉS DES TEXTOS',
        iAgreeText: 'et j’autorise Sephora à utiliser un système automatisé, un composeur automatique, un système automatisé pour la sélection ou la composition de numéros de téléphone, un système de composition téléphonique automatique (« ATDS ») ou tout autre type de système, de logiciel, de matériel, ou machine (peu importe la classification) qui peut utiliser une procédure ou un processus automatisé pour envoyer des messages textes concernant mon rendez-vous au numéro de téléphone cellulaire fourni. Le consentement n’est pas une condition d’achat. Des frais de messagerie texte et de données peuvent s’appliquer. Consultez notre',
        privacyPolicy: 'Politique de confidentialité',
        bookNow: 'Réserver maintenant',
        byCheckingTheBox: 'By checking the box, I acknowledge I have carefully read and fully understand all provisions of the Waiver of Rights and Assumption of Risk',
        waiverOfRights: 'Waiver of Rights and Assumption of Risk',
        assumptionOfRisk: 'and freely and knowingly assume the risk and waive my rights as described.',
        bookingForMinor: 'I am booking for someone under the age of 18.',
        validCreditCard: 'To hold this reservation, a valid credit card is required. Full payment, including taxes, will be made in-store using your preferred method. Gratuity can be added after the service. By placing this order, I agree to the',
        paymentPolicy: 'Payment Policy',
        defaultMethod: 'Default Method',
        weRequireAWaiver: 'We Require A Waiver Of Rights',
        iAcknowledge: 'I acknowledge and accept the',
        onTimePolicy: 'On Time Policy',
        and: 'and',
        cancellationPolicy: 'Cancellation Policy',
        chooseOne: 'Choose One',
        iAmTheParent: 'By checking the box, I acknowledge I am the parent or legal guardian of a minor who is receiving Sephora’s services. I acknowledge I have carefully read and fully understand all provisions of the',
        checkboxErrorText: 'To book, please acknowledge and check the appropriate option below.',
        confirm: 'Confirm',
        payment: 'Payment',
        change: 'Change',
        invalidPhoneNumberError: 'Please enter a valid mobile phone number.',
        phoneInfoText: 'In case we need to contact you about your service.',
        securityCodeError: 'Security code is incorrect'
    };

    return resources[label];
}
